import React from "react";
import {PenTool} from "react-feather";

export default function PenToolDivider({ ...props }) {
    return (
        <div className="divider my-2 mb-2 mt-2">
            <div className="divider-text"><PenTool /></div>
        </div>
    )
}